import React from "react";
import "./blogStyle.css";
import Heading from "../Heading";
import PropTypes from "prop-types";
import ContentPage from "../content-page";
import Meta from "../meta";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import ReactPixel from "react-facebook-pixel";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Link from "gatsby-link";
import {
  TabContent,
  knowledgeResources,
  newsletter,
} from "../../constant/blogConstant";
import { ClipLoader } from "react-spinners";
import MediaQuery from "react-responsive";

const krTabs = [
  "article",
  "case studies",
  "extract",
  "program",
  "podcast",
  "report",
  "research",
  "survey",
  "contributor spotlight"
];

export class Blog extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      Error: {},
      values: {},
      activeKeyword: "",
      isSearching: false,
      Canonical: "",
      browserHistory: [],
      selectedTab: null,
    };
    this.knowledgeResourcesContent = knowledgeResources;
  }
  componentDidMount() {
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
  }
  componentWillMount() {
    if (typeof window !== "undefined") {
      let q = window.location.search.split("=")[1];
      if (q) {
        this.setState({ activeKeyword: q });
        q = q.split("_").join(" ");
        q && this.handleSearch(null, q);
      }
    }
  }

  updateURL = () => {
    if (typeof window !== "undefined") {
      if (this.state.activeKeyword.split(" ").join("_").length) {
        let newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?q=" +
          this.state.activeKeyword.split(" ").join("_");
        window.history.replaceState(
          { path: window.location.pathname },
          "",
          newurl
        );
      } else {
        let newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname;
        window.history.replaceState(
          { path: window.location.pathname },
          "",
          newurl
        );
      }
    }
  };

  selectKRTab = (tabName) => {
    if (tabName !== this.state.selectedTab) {
      this.setState({ selectedTab: tabName });
    } else {
      this.setState({ selectedTab: null });
    }
  };

  handleSearch = (e, q) => {
    // console.log("q", q)
    // console.log("e", e)
    let str =
      q || (e && e.target.value.length ? e.target.value.toLowerCase() : "");
    this.setState({
      isSearching: true,
      activeKeyword: str,
    });
    let videoslist = [...knowledgeResources];
    this.knowledgeResourcesContent = [];
    videoslist.forEach((item) => {
      if (
        item.sdata
          .toLowerCase()
          .trim()
          .search(str) > -1
      ) {
        this.knowledgeResourcesContent.push(item);
      }
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  render() {
    const { isSearching, selectedTab } = this.state;
    const { location, history } = this.props;

    let dataToRender;
    if (selectedTab !== null) {
      dataToRender = this.knowledgeResourcesContent.filter(
        (item) => item.type === selectedTab
      );
    } else {
      dataToRender = this.knowledgeResourcesContent;
    }

    return (
      <ContentPage>
        <Meta
          title={"Winpe | Diversity is Now | Resources"}
          image={
            "http://winpeforum.com/assets/elements/Winpe_Knowledge_centre_banner_400X400.jpg"
          }
          description={
            "Explore and subscribe to industry insights, knowledge resources and updates by the key stakeholders addressing diversity issues in private equity."
          }
          location={location}
        />
        <Meta
          title={"Winpe | Diversity is Now | Resources"}
          image={
            "http://winpeforum.com/assets/elements/WinPE_Knowledge_Centre_link_image.jpg"
          }
          description={
            "Explore and subscribe to industry insights, knowledge resources and updates by the key stakeholders addressing diversity issues in private equity."
          }
          location={location}
        />
        <div className="section__content">
          <div className="blog__wrapper">
            <div className="back_home">
              <Link to="/home">
                <i className="fa fa-arrow-left"> Back to Home</i>
              </Link>
            </div>
            <div className="blog__section">
              <div className="blog_content">
                <div className="low__heading"></div>
                <div className="">
                  <Heading title="KNOWLEDGE RESOURCES" />
                </div>
                <div className="sub__body__text"></div>
                <ScrollAnimation
                  delay={0}
                  duration={2}
                  animateIn="slideInRight"
                  offset={600}
                >
                  <div className="blog_mid_section">
                    <div className="blog_mid_text">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="blog_mid_text">
                            <Tabs>
                              <TabList>
                                {TabContent.map((item, l) => {
                                  return <Tab key={l}>{item.tabName}</Tab>;
                                })}
                              </TabList>
                              <div className="border_end"></div>
                              <TabPanel>
                                <div className="row">
                                  <div className="blog_listing_section">
                                    <div className="knowledgeresources">
                                      <MediaQuery query="(min-width: 768px)">
                                        <div>
                                          <div className="knowledgeresources__tabs">
                                            {krTabs.map((item, i) => (
                                              <div
                                                className={`knowledgeresources__tabs__tab ${this
                                                  .state.selectedTab === item &&
                                                  " knowledgeresources__tabs__tab--selected"}`}
                                                onClick={() =>
                                                  this.selectKRTab(item)
                                                }
                                              >
                                                {item +
                                                  (item !== "research" &&
                                                  item !== "case studies"
                                                    ? "s"
                                                    : "")}
                                                {this.state.selectedTab ===
                                                item ? (
                                                  <span
                                                    style={{
                                                      // display: "inline-block",
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    {" "}
                                                    &#10005;
                                                  </span>
                                                ) : null}
                                              </div>
                                            ))}
                                          </div>
                                         
                                          <div className="listing_heading">
                                            knowledge resources
                                          </div>
                                        </div>
                                      </MediaQuery>
                                      <MediaQuery query="(max-width: 767px)">
                                        <div>
                                          <div className="knowledgeresources__tabs">
                                            {krTabs.map((item, i) => (
                                              <div
                                                className={`knowledgeresources__tabs__tab ${this
                                                  .state.selectedTab === item &&
                                                  " knowledgeresources__tabs__tab--selected"}`}
                                                onClick={() =>
                                                  this.selectKRTab(item)
                                                }
                                              >
                                                {item +
                                                  (item !== "research" &&
                                                  item !== "case studies"
                                                    ? "s"
                                                    : "")}
                                                {this.state.selectedTab ===
                                                item ? (
                                                  <span
                                                    style={{
                                                      // display: "inline-block",
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    {" "}
                                                    &#10005;
                                                  </span>
                                                ) : null}
                                              </div>
                                            ))}
                                          </div>

                                          <div className="listing_heading">
                                            knowledge resources
                                          </div>
                                          <div className="left_scr_box">
                                            <input
                                              type="search"
                                              placeholder="Search"
                                              onChange={(e) =>
                                                this.handleSearch(e)
                                              }
                                              value={this.state.activeKeyword}
                                            />
                                          </div>
                                        </div>
                                      </MediaQuery>
                                    </div>
                                    <div className="row">
                                      {isSearching ? (
                                        <div style={{ margin: "10% 50% 10%" }}>
                                          <ClipLoader
                                            color={"#22316B"}
                                            loading={isSearching}
                                          />
                                        </div>
                                      ) : dataToRender.length ? (
                                        dataToRender.map((item, k) => {
                                          return (
                                            <div
                                              className="col-md-12 col-xs-12 col-sm-12"
                                              key={k}
                                            >
                                              <a
                                                href={item.listlink}
                                                target="_blank"
                                              >
                                                <div className="listing_map">
                                                  <div className="listing_map_date">
                                                    {item.date}
                                                  </div>
                                                  <div className="list_right">
                                                    <div
                                                      className="listing_map_heading"
                                                      dangerouslySetInnerHTML={{
                                                        __html: item.title,
                                                      }}
                                                    ></div>
                                                    <div className="listing_map_subheading">
                                                      {item.auto}
                                                    </div>
                                                  </div>
                                                </div>
                                              </a>
                                            </div>
                                          );
                                        })
                                      ) : (
                                        <div className="no__product">
                                          Not available in the list
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </TabPanel>
                              <TabPanel>
                                <div className="row">
                                  <div className="blog_listing_section">
                                    <div className="listing_heading1">
                                      NewsLetters
                                    </div>
                                    <div className="row">
                                      {newsletter.map((item, k) => {
                                        return (
                                          <div
                                            className="col-md-12 col-xs-12 col-sm-12"
                                            key={k}
                                          >
                                            <Link to={item.listlink}>
                                              <div className="listing_map">
                                                <div className="listing_map_date1">
                                                  {item.datee}
                                                </div>
                                                <div className="list_right1">
                                                  <div
                                                    className="listing_map_heading"
                                                    dangerouslySetInnerHTML={{
                                                      __html: item.title,
                                                    }}
                                                  ></div>
                                                  <div className="listing_map_subheading">
                                                    {item.auto}
                                                  </div>
                                                </div>
                                              </div>
                                            </Link>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </TabPanel>
                            </Tabs>
                          </div>
                        </div>
                      
                      </div>
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
            </div>
          </div>
        </div>
      </ContentPage>
    );
  }
}

Blog.propTypes = {
  location: PropTypes.object,
};

export default Blog;



// WEBPACK FOOTER //
// ./src/components/BlogComponent/index.js